const api = '/rshb-integration-service/api/external';

export const rshbIntegrationContext = {
  branches: `${api}/branches`,
  offices: `${api}/branches/{id}`,
  officeById: `${api}/branches/offices/{id}`,
  merchantSsoLogin: `${api}/csdbo/signin`,
};
